package org.vreo.devicehub.features.userAuthentication.data.dto

import kotlinx.serialization.Serializable

/**
 * User authentication response
 *
 * @param token JWT token used for authentication
 */
@Serializable
data class UserAuthenticationDto(
    val token: String,
)